import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Dashboard = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M20 18V9.908a2 2 0 0 0-.683-1.506l-6-5.25a2 2 0 0 0-2.634 0l-6 5.25A2 2 0 0 0 4 9.908V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-3a2 2 0 1 1 4 0v3a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.81 2.588a2.75 2.75 0 0 0-3.62 0l-6 5.25a2.75 2.75 0 0 0-.94 2.07V18A2.75 2.75 0 0 0 6 20.75h3A1.75 1.75 0 0 0 10.75 19v-3a1.25 1.25 0 1 1 2.5 0v3c0 .967.784 1.75 1.75 1.75h3A2.75 2.75 0 0 0 20.75 18V9.908a2.75 2.75 0 0 0-.94-2.07z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
